module.exports = __webpack_public_path__ + "img/homemsg3.7278f802.png";